import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CustomCheckboxs } from "../../../../Constant";
import { CUSTOM_CHECKBOX } from "../../../../Data/FormControl/CheckboxAndRadio";
import { BorderedCheckboxs } from "./BorderedCheckboxs";
import { IconCheckboxs } from "./IconCheckboxs";
import { FilledCheckboxs } from "./FilledCheckboxs";

const CustomCheckbox = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={CustomCheckboxs} span={CUSTOM_CHECKBOX} />
        <CardBody>
          <Row className="g-3">
            <BorderedCheckboxs />
            <IconCheckboxs />
            <FilledCheckboxs />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CustomCheckbox;
